export const decimalAllowedKeys = /^[0-9,.]|\bBackspace\b|\bTab\b|\bEnter\b$/;
export const numericAllowedKeys = /^[0-9]|\bBackspace\b|\bTab\b|\bEnter\b$/;
export const dotOrComma = /[.,]/;
export const correctDecimalNumber = /^[1-9]*[0-9]*(?:[.,]\d{0,2})?$/;
export const correctNumericNumber = /^[1-9]*[0-9]*/;
export const correctEmailDomain = /((.)\w{2,})+$/;
